/*
 * Чип-переключатель. Из макета: ряд «Требуют действия 3 · Все 48 · По типу»
 * и панель журнала («Мастера: 3 / 6 / 15», «Шаг сетки: 15 мин / 30 мин / 5 мин»).
 */

.chips {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 7px;
  /* Ряд чипов стоит в панели 38 px рядом с подписью; без этого длинная немецкая
     подпись растянет ряд и вытолкнет счётчики за край панели. */
  min-width: 0;
}

.chip {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 5px 12px;
  font-family: var(--font-ui);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  color: var(--text-secondary);
  background: var(--bg-card);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-pill);
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
  /* Перенос по той же причине, что и у кнопки: «Требуют действия» →
     «Handlung erforderlich» не помещается в ту же ширину. */
  white-space: normal;
  text-align: left;
  overflow-wrap: anywhere;
}

@media (pointer: coarse) {
  .chip::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    translate: -50% -50%;
    width: 100%;
    height: 100%;
    min-width: var(--touch-min-target);
    min-height: var(--touch-min-target);
  }
}

.chip:hover:not(:disabled) {
  border-color: var(--text-brand);
  color: var(--text-brand);
}

.chip:active:not(:disabled) {
  background: var(--bg-sunken);
}

/*
 * Выбранный чип. Заливка — не единственный признак: у него ещё aria-pressed="true",
 * поэтому выбор слышно в программе чтения с экрана и видно в проверке в градациях
 * серого (тёмная заливка против светлой).
 */
.chip[aria-pressed="true"] {
  background: var(--chip-active-bg);
  border-color: var(--chip-active-bg);
  color: var(--chip-active-fg);
}

.chip:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.count {
  flex: none;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  line-height: 1.6;
  padding: 0 6px;
  border-radius: var(--radius-pill);
  background: var(--bg-sunken);
  color: var(--text-secondary);
  font-variant-numeric: tabular-nums;
}

/* На выбранном чипе счётчик берёт цвет от самого чипа: одна заливка вместо второго
   токена — и он остаётся читаемым в обеих темах без отдельных значений. */
.chip[aria-pressed="true"] .count {
  background: color-mix(in srgb, currentColor 20%, transparent);
  color: currentColor;
}
